export const MarkerContent = {
  akshit: {
    pune: {
      position: {lat: 18.4915, lng: 73.8217},
      title: 'I am here',
      location: 'Pune, Maharashtra',
      description: 'I\'ve been here since 2017.'
    },
    nagpur: {
      position: {lat: 21.0989, lng: 79.0926},
      title: 'I was here',
      location: 'Nagpur, Maharashtra',
      description: 'I was here until 2017. It is my hometown. I have lived here for about 20 years. We have a house here, which is our own.'
    },
    buldhana: {
      position: {lat: 20.0148, lng: 76.0323},
      title: 'I was here',
      location: 'Deulgaon, Buldhana, Maharashtra',
      description: 'I was here for a year when i was young. I did my 5th grade here. It is a small village in Maharashtra. It did not have an english school, so i had to go to the nearby town, Jalna, for school every day. I remember the place quite well. I lived on first floor of a building which was just in front of the highway. There was greenery and empty space behind the building and all around it.'
    },
    jalna: {
      position: {lat: 19.8626, lng: 75.9004},
      title: 'I was here',
      location: 'Jalna, Maharashtra',
      description: 'I did my 5th grade here. I used to travel from Deulgaon to Jalna every day for school. This was the best school i\'ve been to. I still remember it fondly. It has a huge sports ground, and they had a huge sports event every year. There was a small canteen also in the school which was quite intriguing for me. I did not have any friends in my own class, but I was close to people I travelled with in a small car. They were really good people. And I also went to a tuition class in Jalna with them after school.'
    },
    beltarodi: {
      position: {lat: 21.0752, lng: 79.0772},
      title: 'I was here',
      location: 'Beltarodi, Nagpur',
      description: 'I studied here from 7th grade to 10th grade. This was an okayish school, some teachers were not good to me, and some bad things happened here. But some good things that i liked about this school was the science exhibitions, and the friends i had made there, although they are not my friends anymore since two years after I left the school.'
    },
    hingna: {
      position: {lat: 21.1026, lng: 79.0036},
      title: 'I was here',
      location: 'Hingna, Nagpur',
      description: 'I studied computer science here. The college premises were really nice, and the teachers were good. There was a lake inside the campus, and also huge ground, and swimming pool. I made good friends here as well, and they have been my longest friends ever.'
    },
    akola: {
      position: {lat: 20.7072, lng: 77.0029},
      title: 'I was here',
      location: 'Akola, Maharashtra',
      description: 'I was here for a year and did my 6th grade here. I did not like it much. I did not have any friends there and the teachers and students were not good. The school was also not very good. I was happy to leave this place after a year.'
    },
    panchawati: {
      position: {lat: 18.5310, lng: 73.8118},
      title: 'I was here',
      location: 'Panchawati, Pune',
      description: 'I lived here and studied here for a few months from Aug 2017 to Feb 2018. I lived in a PG with some of my friends. It was a nice place. I struggled to eat well here as there was no good food available.'
    },
    hinjewadi: {
      position: {lat: 18.5904, lng: 73.7367},
      title: 'I work here',
      location: 'Hinjewadi, Pune',
      description: 'My office is here. I dont really like this place, the vibe here seems a bit off to me.'
    },
    mcleodganj: {
      position: {lat: 32.2403, lng: 76.3236},
      title: 'I was here',
      location: 'Mcleodganj, Himachal Pradesh',
      description: 'I went here for my first solo trip in Dec 2024 for new years. I did not tell anyone about this trip. I really liked the place, the views of the mountains just outside the hostel balcony where i stayed were amazing. And I walked around a lot to see more mountains up close. And the food in the hostel was good, and I tried some nice cafes nearby.'
    },
    manali: {
      position: {lat: 32.25, lng: 77.18},
      title: 'I was here',
      location: 'Manali, Himachal Pradesh',
      description: 'I went here for my second solo trip in Mar 2025. I stayed in a hostel here as well. It is a good place, but more than that, i made some friends on this trip as they stayed with me in my room. And also, i got to see some snow for the first time!'
    },
    coorg: {
      position: {lat: 12.42, lng: 75.74},
      title: 'I was here',
      location: 'Coorg, Karnataka',
      description: 'I went here with my family for a vacation in Jun 2022. We stayed in a homestay here. The place was really nice, and the weather was amazing. It was a good trip. My family really liked it.'
    },
    ooty: {
      position: {lat: 11.41, lng: 76.70},
      title: 'I was here',
      location: 'Ooty, Tamil Nadu',
      description: 'I went here with my family for a vacation in Jun 2022. We stayed in a hotel here. The place was okay, not better than Coorg though, and the weather was good. But there was pollution and the place was quite crowded.'
    },
    varca: {
      position: {lat: 15.2324, lng: 73.9431},
      title: 'I was here',
      location: 'Varca, Goa',
      description: 'I went here with my family for a vacation in Feb 2024. We stayed in a homestay here. The place was really nice, my mom loved the homestay, as it was run by a family, and we became friends with them. The beach was also really nice, with white sand and clear water.'
    },
    mysore: {
      position: {lat: 12.3068, lng: 76.6387},
      title: 'I was here',
      location: 'Mysore, Karnataka',
      description: 'I went here with my family for a vacation in Jun 2022. We stayed in a hotel here. The place was really nice, and the weather was good.'
    },
    bangalore: {
      position: {lat: 12.9716, lng: 77.5946},
      title: 'I was here',
      location: 'Bangalore, Karnataka',
      description: 'I went here with my family for a vacation in Jun 2022. We stayed in a hotel here. It was a bit crowded though, and a lot of traffic. But still it was good.'
    }
  },
  nivi: {
    kakkanad: {
      position: {lat: 10.0159, lng: 76.3419},
      title: 'You are here',
      location: 'Kakkanad, Kerala',
      description: 'You\'ve been here since Feb 2026.'
    },
    navimumbai: {
      position: {lat: 18.9174, lng: 73.1986},
      title: 'You were here',
      location: 'Navi Mumbai, Maharashtra',
      description: 'You were here for four years. You left in Feb 2026. A lot of things happened when you were here, about college and your health, and Fausto.'
    },
    mumbai: {
      position: {lat: 19.2005, lng: 72.8737},
      title: 'You were here',
      location: 'Mumbai, Maharashtra',
      description: 'You were here since you were in school. Your childhood memories are here. You have your own room here which you really liked.'
    },
    pune_symbiosys: {
      position: {lat: 18.5367, lng: 73.7318},
      title: 'You were here',
      location: 'Pune, Maharashtra',
      description: 'You were here from 2022 to 2025. You studied photography here and gratuated in September 2025. You stayed in the campus hostel.'
    },
    vu_mumbai: {
      position: {lat: 19.0206, lng: 73.5199},
      title: 'You were here',
      location: 'Mumbai, Maharashtra',
      description: 'You were here in 2020-2021. You studied photography and music here and then dropped out. You stayed in the campus hostel.'
    },
    bhis_mumbai: {
      position: {lat: 19.0585, lng: 72.8341},
      title: 'You were here',
      location: 'Mumbai, Maharashtra',
      description: 'You studied in this school. You also did you high school here and played lot of basketball.'
    },
    amsterdam: {
      position: {lat: 52.0705, lng: 4.3007},
      title: 'You were here',
      location: 'Amsterdam, Netherlands',
      description: 'You were here when you were very smol. You lived here for a few years before moving to Mumbai. You loved it a lot and you did not want to leave. You had some friends in the school that were from different countries. You used to wakeup to the lovely scent of chocolates from the chocolate factory nearby. You remember the house very well, it was a three floor house. And there was a lake nearby.'
    },
    losangeles: {
      position: {lat: 34.0148, lng: -119.5942},
      title: 'You were here',
      location: 'Los Angeles, California, USA',
      description: 'You went to USA in 2017 for the first time. It was a family trip and you stayed with your family there. You also went to the Grand Canyon and Las Vegas on the same trip.'
    },
    vietnam: {
      position: {lat: 14.0583, lng: 108.2772},
      title: 'You were here',
      location: 'Da Nang, Hanoi, Vietnam',
      description: 'You went to Vietnam for a vacation with your family in Jan 2024. You visited Hanoi, Halong Bay, and Da Nang. You loved the food there and the people were very nice. Although you had to use the wheelchair, you still tried your best to enjoy the trip.'
    },
    miyarvalley: {
      position: {lat: 32.9600, lng: 76.8167},
      title: 'You were here',
      location: 'Miyar Valley, Himachal Pradesh, India',
      description: 'You went to Miyar Valley for a trek in June 2022. It was a very difficult trek but you had prepared very well for it. You enjoyed the beautiful views and the experience of being in the mountains. You took you camera with you and took a lot of pictures. You also made some good friends on the trek.'
    }
  },
  akshit_nivi: {
    westend_2023: {
      position: {lat: 18.5619, lng: 73.8070},
      title: 'We were here!',
      location: 'Westend Mall, Aundh',
      description: 'We met here in 2023 for the first time. We just roamed around the mall, and you had a chocolate donut in the food court.'
    }
  }
}